import React, { createContext, useState, useMemo, useContext, useEffect } from "react"
import Api from "../__helpers/api";
import { useAuthDataContext } from './AuthProvider';

export const AppDataContext = createContext({});

const AppDataProvider = props => {
    const auth = useAuthDataContext()

    const hasBoard = auth?.user?.center?.board && auth?.user?.user_type_id != 1

    const [appData, setAppData] = useState({
        boardStatus: {
            loading: true,
            connected: false,
            reconnect: false,
            data: []
        }
    })

    const startBoardLoading = () => {
        setAppData(prev => ({
            ...prev,
            boardStatus: {
                ...prev.boardStatus,
                loading: true
            }
        }))
    }

    const stopBoardLoading = () => {
        setAppData(prev => ({
            ...prev,
            boardStatus: {
                ...prev.boardStatus,
                loading: false
            }
        }))
    }

    const toggleBoardConnection = () => {
        setAppData(prev => ({
            ...prev,
            boardStatus: {
                ...prev.boardStatus,
                connected: prev.boardStatus.connected ? false : true
            }
        }))
    }

    const reconnect = () => {
        setAppData(prev => ({
            ...prev,
            boardStatus: {
                ...prev.boardStatus,
                reconnect: new Date()
            }
        }))
    }





    //START CONTROLLER

    //new global vars
    let AVTO_API
    let LED_CHANNELS

    useEffect(() => {

        const API_URL = "ws://avto.local/chat";

        const MSG_ADDRESS_OFFSET = 0;
        const MSG_COMMAND_OFFSET = 1;
        const MSG_DATA_OFFSET = 2;
        const MSG_CRC_OFFSET = 1;

        const CMD_GET_NODES = 0;
        const CMD_ALL_ON = 1;
        const CMD_ALL_OFF = 2;

        const re = new RegExp("^#[0-9a-fA-F]{4}[0-9a-fA-F]{2}[0-9a-fA-F]+$");

        // Transfer buffer
        const msg_buffer = new ArrayBuffer(8);
        for (var i = 0; i < 8; i++)
            msg_buffer[i] = 0;

        var API
        var ws = hasBoard ? new WebSocket(API_URL) : '';
        var user_data_callback = null;
        var devicelist = [];
        var tm;

        function parse_frame(msg) {
            var address = msg.substr(1, 8);
            var opcode = parseInt(msg.substr(9, 2), 16);
            var len = 0;
            var data = null;


            if (msg.length > 11) {
                len = parseInt(msg.substr(11, 2), 16);
            }

            if ((len * 2) == (msg.length - 13)) {
                data = msg.substr(13);
            }

            return {
                "addr": address,
                "op": opcode,
                "len": len,
                "data": data
            };

        }

        function process_frame(frame) {
            switch (frame.op) {
                case 0x82:
                    devicelist = [];
                    break;
                case 0x83:
                    if (typeof API.ondevicelist === 'function')
                        API.ondevicelist(devicelist);
                    break;
                case 0x80:
                    devicelist.push(frame.data);
                    break;
            }
        }

        function buf2hex(buffer) {
            var str = "";
            for (var i = 0; i < 8; i++) {
                str += buffer[i].toString(16).padStart(2, "0").toUpperCase();
            }
            return str;
        }

        function __ping__() {
            ws.send('');
            tm = setTimeout(function () {
                connect();
            }, 5000);
        }

        function __pong__() {
            clearTimeout(tm);
        }

        var on_ws_event = function (e) {
            // if(e.data == "__pong__"){
            //     __pong__();
            // }
            var frame;
            if (re.test(e.data)) {
                console.log("OK", e.data);
                frame = parse_frame(e.data);
                process_frame(frame);
            }

            // if(e.data.indexOf("#NS:") === 0)
            // {
            //     devicelist = [];
            // } 
            // else if(e.data.indexOf("#NN:") === 0)
            // {
            //     devicelist.push(parseInt(e.data.substr(4)));
            // }
            // else if(e.data.indexOf("#NE") === 0)
            // {
            //     if(typeof API.ondevicelist === 'function'){
            //         API.ondevicelist(devicelist);
            //     }
            // }

            if (typeof API.onmessage === 'function') {
                API.onmessage(e);
            }
        }
        function connect() {
            if (!hasBoard) return

            console.log("Connecting");
            ws = new WebSocket(API_URL);
            startBoardLoading()
            ws.onopen = function () {
                console.log("Open ws");
                // subscribe to some channels
                ws.send("#0000000001");
                //   setInterval(__ping__, 30000);
                Api.get('center/road-signs')
                    .then(res => {
                        console.log(res.data)
                        setAppData(prev => ({
                            ...prev,
                            boardStatus: {
                                ...prev.boardStatus,
                                data: res.data
                            }
                        }))
                    })
                    .finally(() => {
                        stopBoardLoading()
                    })
                setAppData(prev => ({
                    ...prev,
                    boardStatus: {
                        ...prev.boardStatus,
                        connected: true
                    }
                }))
            };

            ws.onmessage = on_ws_event;

            ws.onclose = function (e) {
                console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason);
                // setTimeout(function () {
                //     connect();
                // }, 1000);
            };

            ws.onerror = function (err) {
                console.error('Socket encountered error: ', err.message, 'Closing socket');
                ws.close();
                stopBoardLoading()
                setAppData(prev => ({
                    ...prev,
                    boardStatus: {
                        ...prev.boardStatus,
                        connected: false
                    }
                }))
            };
        }

        function api_command(address = 0x00000000, opcode = 0x00, data) {
            // if(typeof address != "number"){
            address = parseInt(address);
            // }
            msg_buffer[0] = address;

            // if(typeof opcode != "number"){
            opcode = parseInt(opcode);
            // }
            msg_buffer[1] = opcode;

            if (typeof data != "number") {
                return false;
            }
            msg_buffer[5] = (data & 0xff);
            data >>= 8;
            msg_buffer[4] = (data & 0xff);
            data >>= 8;
            msg_buffer[3] = (data & 0xff);
            data >>= 8;
            msg_buffer[2] = (data & 0xff);
            // calcCrc();
            ws.send(buf2hex(msg_buffer));
        }

        function api_scan_devices(callback) {
            ws.send("#0000000001");
        }

        function api_all_off(callback) {
            // .... callback(device list)
        }

        function api_all_on() {

        }

        function api_set_reset_by_mask(address, mask, set = true) {

        }

        API = {
            "connect": connect,
            "isConnected": function () {
                return (ws.readyState == WebSocket.OPEN);
            },
            "scanForDevices": function () {
                ws.send("#0000000001");
            },
            "turnAllOff": function (address) {
                ws.send("#" + address + "03");
            },
            "turnAllOn": function (address) {
                ws.send("#" + address + "02");
            },
            "setLeds": function (address, mask) {
                var msg = "#" + address + "0403" + mask.toString(16).padStart(6, "0");
                ws.send(msg);
            },
            "setSelected": function (address, mask) {
                var msg = "#" + address + "0503" + mask.toString(16).padStart(6, "0");
                ws.send(msg);
            },
            "resetSelected": function (address, mask) {
                var msg = "#" + address + "0603" + mask.toString(16).padStart(6, "0");
                ws.send(msg);
            },
            "onmessage": null,
            "ondevicelist": null
        };

        window.AVTO_API = API;
        window.LED_CHANNELS = 24;

    }, [])

    var TempObj = {
        "addr": "00000000",
        "op": "00",
        "dataLen": 0,
        "data": null
    };
    var deviceList = [];
    var connected = false;
    var led_state = 0;

    function onNodeChange(posterId) {
        // var sel = document.getElementById("param_node");
        // var opt = sel.options[sel.selectedIndex];

        // TempObj.addr = sel.options[sel.selectedIndex].value;
        // document.getElementById("sel_dev_id").innerText = "Device: " + opt.innerText

        TempObj.addr = posterId;

    }

    function onCommandChange() {
        // var sel = document.getElementById("param_cmd");
        // TempObj.opcode =  parseInt(sel.options[sel.selectedIndex].value) & 0xff;
    }

    // 
    function onChannelChange(id) {
        led_state = 0x00000000; // 32 bit container

        if (id && id[0]) {
            for (var i = 0; i < id.length; i++) {
                led_state |= (1 << id[i] - 1)
            }
        } else {
            led_state |= (1 << id);
        }

    }

    function updateNodeList() {
        // var sel = document.getElementById("param_node");
        // sel.innerHTML = "";

        // Add broadcast address
        var opt = document.createElement("option");;
        opt.value = '00000000';
        opt.innerText = "*All devices";
        opt.selected = 'selected';
        // sel.appendChild(opt);
        // sel.selectedIndex = 0;

        for (var i = 0; i < deviceList.length; i++) {
            opt = document.createElement("option");
            opt.value = deviceList[i];
            opt.innerText = "(" + deviceList[i].toString(16).padStart(8, "0").toUpperCase() + "h) Device #" + (i + 1);
            // sel.appendChild(opt);
        }

        // selectedIndex
        onNodeChange();
    }

    function updateChannelList() {
        // var container = document.getElementById("channels");
        var input_cb, lbl, c;
        for (var i = 0; i < LED_CHANNELS; i++) {
            c = document.createElement("div");
            c.setAttribute("class", "ch_item");

            // if(i > 0 && i % 8 == 0){
            //     container.appendChild(document.createElement("br"));
            // }
            input_cb = document.createElement("input");
            input_cb.type = 'checkbox';
            input_cb.id = 'io' + i;
            input_cb.value = 'io' + i;
            input_cb.onchange = onChannelChange;
            c.appendChild(input_cb);

            lbl = document.createElement('label');
            lbl.setAttribute('for', input_cb.id);
            lbl.innerHTML = 'Out.' + (i + 1);
            c.appendChild(lbl);
            // container.appendChild(c);
        }
    }

    function sendCommand() {
        window.AVTO_API.command(TempObj.addr, TempObj.opcode, TempObj.data);
    }

    function checkConnection() {

        var ws_con = window.AVTO_API.isConnected();
        var info = document.getElementById("info_box");

        if (info) {
            if (!connected && ws_con) {
                // Connect
                info.setAttribute("class", "ws_state ws_con");
                info.getElementsByTagName("p")[0].innerText = "Network available";

            } else if (!ws_con && connected) {
                // Disconnect
                info.setAttribute("class", "ws_state ws_dis");
                info.getElementsByTagName("p")[0].innerText = "No connection!";
            }
        }
        connected = ws_con;
        setTimeout(function () {
            checkConnection();
        }, 1000);
    }

    function turnAllOn() {
        window.AVTO_API.turnAllOn(TempObj.addr);
    }

    function turnAllOff() {
        window.AVTO_API.turnAllOff(TempObj.addr);
    }

    function setLeds() {
        window.AVTO_API.setLeds(TempObj.addr, led_state);
    }

    function setSelectedLeds() {
        window.AVTO_API.setSelected(TempObj.addr, led_state);
    }

    function resetSelectedLeds() {
        window.AVTO_API.resetSelected(TempObj.addr, led_state);
    }

    useEffect(() => {
        updateNodeList();
        updateChannelList();

        onChannelChange();
        onCommandChange();

        // AVTO_API.onmessage = function (e) {
        //     // @user handle of websocked event message
        // };

        // AVTO_API.ondevicelist = function (items) {
        //     deviceList = [];
        //     for (var i = 0; i < items.length; i++) {
        //         // console.log(items[i]);
        //         deviceList.push(items[i]);
        //     }
        //     document.getElementById("info_box").innerHTML = "<p>" + deviceList.length.toString() + " nodes found in network</p>"
        //     updateNodeList();
        //     document.getElementById("dev_num_id").innerText = " " + deviceList.length + " devices";
        // };
        window.AVTO_API.connect();
        checkConnection();
    }, [appData.boardStatus.reconnect])

    //END CONTROLLER





    const app = useMemo(() => ({
        ...appData,
        startBoardLoading,
        stopBoardLoading,
        toggleBoardConnection
        //
        ,
        onChannelChange,
        onNodeChange,
        resetSelectedLeds,
        setSelectedLeds,
        onNodeChange,
        onChannelChange,
        setSelectedLeds,
        turnAllOff,
        reconnect

    }), [appData])

    return <AppDataContext.Provider value={app} {...props} />
}

export const useAppDataContext = () => useContext(AppDataContext)

export default AppDataProvider